<xemex-dialog-shell [title]="'devices.resetDeviceDialog.title' | translate">
  <div class="p-2">
    <span>{{ 'devices.resetDeviceDialog.message' | translate }}</span>
  </div>
  <mat-dialog-actions actions>
    <button mat-flat-button (click)="onConfirm()" color="warn">
      {{ 'general.btnConfirm' | translate }}
    </button>
    <button mat-stroked-button mat-dialog-close type="button">
      {{ 'general.btnCancel' | translate }}
    </button>
  </mat-dialog-actions>
</xemex-dialog-shell>
